const profile = {
  profile: {
    title: 'Profile Settings',
    subtitle: 'Manage your account information',
    editProfile: 'Edit Profile',
    cancel: 'Cancel',
    saving: 'Saving...',
    saveChanges: 'Save Changes',
    signOut: 'Sign Out',

    // Tabs
    profileTab: 'Profile',
    favoritesTab: 'Favorites',

    // Form Labels
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email Address',

    // Account Information
    accountInfo: 'Account Information',
    userId: 'User ID',
    accountCreated: 'Account Created',
    emailVerified: 'Email Verified',
    lastSignIn: 'Last Sign In',
    yes: 'Yes',
    pending: 'Pending',
    never: 'Never',

    // Help Section
    needHelp: 'Need Help?',
    helpText: 'Contact our support team if you need assistance with your account.',
    contactSupport: 'Contact Support',

    // Validation Messages
    firstNameRequired: 'First name is required',
    firstNameTooShort: 'First name must be at least 2 characters long',
    firstNameTooLong: 'First name must be less than 50 characters',
    lastNameRequired: 'Last name is required',
    lastNameTooShort: 'Last name must be at least 2 characters long',
    lastNameTooLong: 'Last name must be less than 50 characters',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email address',

    // Success/Error Messages
    updateSuccess: 'Profile updated successfully!',
    updateError: 'Failed to update profile. Please try again.',
    emailChangeNote: 'Changing your email will require verification',

    // Favorites
    noFavorites: 'No favorites yet',
    noFavoritesDescription: 'Start browsing properties and save your favorites to see them here.',
    browseProperties: 'Browse Properties',
    unknownProperty: 'Unknown Property',
  },
};

export default profile;
